import { TmsValue } from 'data/records'
import { resource, collection, findSelector } from 'data/helpers/apiv3'

const [api, actions] = resource(TmsValue, [
  ['list', collection.get('', ['tmsSetId', 'q'])]
])

const selectors = {
  ...findSelector(TmsValue),
  byTmsSetId: (state, setId) => state.apiv3.tmsValue.id.filter(v => v.tmsSetId === setId)
}

const reducers = {}

const initialState = {}

export {
  api as tmsValueApi,
  actions as tmsValueActions,
  selectors as tmsValueSelectors,
  reducers as tmsValueReducers,
  initialState as tmsValueInitialState
}
